
const Home = () => {
  return (
    <div className="text-gray-700 leading-8 text-xl bg-gray-200 p-5 xl:p-10 text-left flex justify-center">
      <div className="bg-white w-11/12 xl:w-10/12 rounded-xl p-3 xl:p-20">
        <h1 className="text-3xl font-bold mb-4">プライバシーポリシー</h1>
        <p className="mb-4">eco.qsofが開発しました「カタカナよめるよ」（以下、当アプリケーション）は、ユーザーのプライバシーを尊重し、
          <br />個人情報を収集いたしません。以下は、当アプリケーションのプライバシーポリシーに関する詳細です。</p>

        <h2 className="text-2xl font-semibold mb-2">1. 収集する情報</h2>
        <p className="mb-4">当アプリケーションは、ユーザーから個人情報を収集いたしません。<br />
          利用状況やエラーログなどの匿名のデータは、サービス向上のために収集される場合がありますが、これは個別のユーザーを特定するためのものではありません。</p>

        <h2 className="text-2xl font-semibold mb-2">2. デバイス情報の利用</h2>
        <p className="mb-4">当アプリケーションは、デバイスのモデル、オペレーティングシステムのバージョンなどの一般的なデバイス情報を収集する場合があります。
          <br />これは、アプリケーションの互換性やパフォーマンスの向上のために使用されます。</p>

        <h2 className="text-2xl font-semibold mb-2">3. ユーザーのコンセント</h2>
        <p className="mb-4">アプリケーションはユーザーの明示的なコンセントなしに個人情報を収集いたしません。<br />
          特定の機能やサービスを利用する際には、ユーザーに対して事前に情報の収集に同意を求めることがあります。</p>

        <h2 className="text-2xl font-semibold mb-2">4. 広告とアクセス解析</h2>
        <p className="mb-4">当アプリケーションは広告やアクセス解析のためにサードパーティのサービスを利用する場合があります。
          <br />これらのサービスが収集する情報については、それぞれのプライバシーポリシーを確認してください。</p>

        <h2 className="text-2xl font-semibold mb-2">5. プライバシーポリシーの変更</h2>
        <p className="mb-4">当アプリケーションは、プライバシーポリシーを変更する権利を留保します。
          <br />変更がある場合は、アプリ内で通知いたします。</p>

        <h2 className="text-2xl font-semibold mb-2">6. お問い合わせ先</h2>
        <p className="mb-4">プライバシーポリシーに関するご質問やお問い合わせがございましたら、以下の連絡先までお気軽にお問い合わせください。</p>

        <p>[お問い合わせ先] 092-433-5366</p>
        <p>[運営者名] 株式会社九州ソフタス福岡支店</p>
        <p>[住所] 〒812-0011　福岡県福岡市博多区博多駅前3-25-24 八百治ビル3F</p>
        <p>[メールアドレス] ecosystem@kyushu-softas.co.jp</p>
      </div>
    </div>
  );
};

export default Home;